import { createAction } from "@reduxjs/toolkit";

export const getSpecializationsSuccess = createAction('specializations/getSuccess')
export const getSpecializationsError = createAction('specializations/getError')
export const clearSearch = createAction("specializations/clearSearch")
export const setSpecializationsDiscount = createAction("specializations/setSpecializationsDiscount")